import { FilterArea } from "#src/components/FilterArea";
import { StorageKeys, TextInput } from "@validereinc/common-components";
import React from "react";

export const WORKERS_TABLE_FILTER_KEYS = {
  name: "name",
} as const;

export const WorkersTableFilterArea = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => {
  return (
    <FilterArea.Root
      storageKey={filterConfigStorageKey}
      defaultValues={{}}
    >
      <FilterArea.Container aria-label="Filters for Workers">
        <FilterArea.Content>
          {({ handleOnChange }) => (
            <div style={{ marginBottom: 0, marginRight: 8 }}>
              <TextInput
                name={WORKERS_TABLE_FILTER_KEYS.name}
                type="search"
                placeholder="Search by name..."
                isLabelShown={false}
                isInline
                onChange={(val) =>
                  handleOnChange(val, WORKERS_TABLE_FILTER_KEYS.name)
                }
              />
            </div>
          )}
        </FilterArea.Content>
      </FilterArea.Container>
    </FilterArea.Root>
  );
};
